const CreateFormDescriptionInput = ({ placeholderText }) => {
  return (
    <div className="description-area pt-6 w-full">
      <textarea placeholder={placeholderText}></textarea>
    </div>
  );
};

export default CreateFormDescriptionInput;
